import "./Contacts.module.css";
import GatewayNavigation from "@/reusable_sections/Header";
import ContactHeroSection from "./sections/ContactHeroSection";
import StepsFromTheSacred from "./sections/StepsFromTheSacred";
import Receptionschedulecarousel from "./sections/Receptionschedulecarousel";
import ContactConsultation from "./sections/ContactConsultation";
import Footer from "@/reusable_sections/Footer";
export default function ContactsPage() {
  return <div>
      <GatewayNavigation />
      <ContactHeroSection />
      <StepsFromTheSacred />
      <Receptionschedulecarousel />
      <ContactConsultation />
      <Footer />
    </div>;
}